import { Container } from 'inversify';
import { interfaces } from 'inversify/lib/interfaces/interfaces';

import { getDependencies } from './utils';

export class DIContainer extends Container {

  get <T>(serviceIdentifier: interfaces.Newable<T>): T {

    return getDependencies(serviceIdentifier, super.get.bind(this), super.isBound.bind(this));
  }

}
